module.exports = __webpack_public_path__ + "img/bsignup-continue-2@3x.63a3a647.png";